import React, { FC } from 'react';
import { PatternFormat } from 'react-number-format';
import { TextField } from '@mui/material';
import { FieldRenderProps } from 'react-final-form';

interface Props extends FieldRenderProps<number | string> {
  numberFormat: string;
  numberPlaceholder: string;
  maxLength: number;
}

const NumberFormatAdapter: FC<Props> = ({
  input: { onChange, inputRef, type, ...other },
  CustomInput,
  numberPlaceholder,
  numberFormat,
  maxLength,
  ...rest
}) => (
  <PatternFormat
    {...rest}
    {...other}
    getInputRef={inputRef}
    onChange={onChange}
    customInput={CustomInput || TextField}
    maxLength={maxLength}
    format={numberFormat}
    placeholder={numberPlaceholder}
  />
);

export default NumberFormatAdapter;
